import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DateState {
  selectedDate: string;
}

const initialState: DateState = {
  selectedDate: new Date().toISOString().split("T")[0], // Use empty string as default instead of null
};

const dateSlice = createSlice({
  name: "date",
  initialState,
  reducers: {
    ModDemoSelectedDate: (state, action: PayloadAction<string>) => {
      state.selectedDate = action.payload;
    },
  },
});

export const { ModDemoSelectedDate } = dateSlice.actions;
export default dateSlice.reducer;
